<template>
  <div class="content">
    <p class="title">数字证书服务协议</p>
    <p>
      您正在向大陆云盾电子认证服务有限公司（以下简称"大陆云盾"）申请数字证书服务，该服务可用于电子签名、电子签章、身份认证及数据加解密等应用场景。为保障您的合法权益，
      <strong>请您在申请前认真阅读并充分理解《大陆云盾数字证书服务协议》（以下简称"本协议"）的全部条款。</strong>
    </p>
    <p><strong>【重要提示】</strong></p>
    <p><strong>如您点击确认或提交申请，</strong>即视为您（也称<strong>"用户"</strong>或<strong>"订户"</strong>）已阅读、理解并同意本协议全部条款，您与大陆云盾之间的数字证书服务合同关系自此成立，并对双方具有法律约束力。</p>
    <p><strong>如您不同意本协议，</strong>请立即退出本申请流程，停止使用相关服务。</p>
    <p>
      大陆云盾是依法设立的全国性第三方电子认证服务机构，已取得中华人民共和国工业和信息化部《电子认证服务许可证》等相关资质。
      为明确各方的权利义务，大陆云盾依据《中华人民共和国民法典》《中华人民共和国电子签名法》《电子认证服务管理办法》
      《大陆云盾电子认证业务规则》（以下简称"CPS"，发布于大陆云盾官方网站<a href="https://www.msca.org.cn/cps.htm" target="_blank">https://www.msca.org.cn/cps.htm</a>），特制定本协议。</p>
    <h1>第一条 用户的权利和义务</h1>
    <p>1.1.用户可使用数字证书进行法律允许的民事、商业及政务活动，不得用于违反法律法规、危害国家安全、侵害他人合法利益等非法用途。</p>
    <p>用户在申请数字证书时，须向大陆云盾提交<strong>完整、真实、准确且有效</strong>的个人信息及相关证明材料，具体要求如下：
      （1）个人用户：姓名、有效身份证件号码、实名手机号码、电子邮箱及联系地址；
      （2）机构用户：机构名称、有效营业执照（或同等法律效力证明文件）、电子邮箱、联系地址，以及法定代表人及经办人的姓名、
      有效身份证件号码、实名手机号码，非法定代表人办理的，还须提供加盖机构公章的授权委托书。
    </p>
    <p>
      1.2.数字证书有效期内，如用户信息发生任何变更，<strong>用户应于变更发生之日起72小时内</strong>通知大陆云盾或其授权注册机构，
      并配合完成证书变更手续。用户未主动通知的，大陆云盾有权依据原有信息继续提供服务，由此产生的一切后果由用户承担。
      若用户存在下列任一情形，致使证书签发错误、被撤销或给任何一方造成损失的，用户须<strong>承担全部法律责任及相应赔偿责任，</strong>
      且大陆云盾有权向用户追偿因此遭受的全部损失（包括但不限于直接损失、间接损失、律师费、调查取证费等）：
      （1）提交虚假、伪造或变造的信息或材料；（2）以欺骗、窃取等非法手段获取或提交证明材料；
      （3）用户信息发生变更后，未按本条约定及时通知并更新。
    </p>
    <p>
      1.3.
      <strong>
        用户本次申请数字证书服务及后续使用证书的相关费用均由  <span style="text-decoration: underline;">  重庆易保全网络科技有限公司  </span>   承担，用户无需向大陆云盾支付证书服务费用。
      </strong>
    </p>
    <p>
      1.4.用户自行生成数字证书的私钥时，应采取有效的安全保护措施（包括但不限于使用强密码、启用多重身份验证、定期更换密码等），
      在生成及使用过程中如遇到困难或障碍可向大陆云盾申请协助。
      <strong>用户委托第三方平台管理私钥的，应审慎评估第三方平台资质和安全保障能力，并自行承担私钥委托风险。</strong>
    </p>
    <p>
      1.5.若用户遭遇私钥或密码泄露、证书遗失或发生其他安全风险事件，应立即联系大陆云盾进行证书撤销处理。
      用户怠于通知或撤销的，自风险事件发生之时起至实际撤销之日止产生的全部法律后果及损失由用户自行承担。
      证书撤销后或有效期届满时，应立即停止使用相关证书及私钥。
      因用户保管不当、未及时申请证书撤销或继续使用已失效/被撤销证书所导致的法律后果及损失，由用户自行承担。
    </p>
    <p>
      1.6.用户应积极配合大陆云盾就证书使用情况、安全事件等进行的调查，如实提供相关信息和材料。用户拒绝配合或提供虚假信息的，
      大陆云盾有权暂停或撤销证书，并追究用户相应责任。CPS详细规定了数字证书服务的操作规范与安全要求，
      用户可随时登录大陆云盾官方网站<a href="https://www.msca.org.cn/cps.htm" target="_blank">https://www.msca.org.cn/cps.htm</a>进行查阅。
    </p>
    <h1>第二条 大陆云盾的权利和义务</h1>
    <p>
      2.1.大陆云盾依据有关法律法规对数字证书进行管理，对用户提交的身份信息和证明材料进行严格审核。
      审核通过后，为用户签发数字证书，保证数字证书内容完整、准确，并妥善保存有关的信息至证书失效后五年。
    </p>
    <p>2.2.大陆云盾为用户免费提供数字证书查询及数字证书状态查询服务。</p>
    <p>2.3.用户因使用大陆云盾签发的数字证书产生争议时，可向大陆云盾申请提供技术配合。</p>
    <p>
      2.4.存在以下情形之一时，大陆云盾<strong>有权不经事先通知，冻结或撤销证书：</strong>
      （1）用户提供虚假、不完整或缺失的申请资料；
      （2）用户未遵守本协议所规定的义务；
      （3）大陆云盾或其授权的注册机构合理怀疑证书存在安全风险；
      （4）证书被用于非法或犯罪活动；（5）法律法规规定的其他撤销情形。
    </p>
    <p>
      2.5.大陆云盾有权根据系统维护、升级、安全检测等技术需要，在提前合理时间公告后，暂停部分或全部服务。
      因上述原因导致的服务暂停，大陆云盾不承担违约责任。
    </p>
    <p>
      2.6.大陆云盾将依照法律规定及本协议约定提供数字证书服务，并在法定及约定范围内承担相应责任。
    </p>
    <h1>第三条 用户申请与使用数字证书</h1>
    <p>
      3.1.用户应基于使用需求申请相适应的数字证书，并在使用数字证书时须严格遵守CPS中相关的规定。
    </p>
    <p>
      3.2.用户在获得数字证书时应及时验证证书匹配的主体信息，
      在收到证书后<span style="text-decoration: underline;">三个工作日内</span>未对数字证书或数字证书内容提出异议的视为接受数字证书。
    </p>
    <p>
      3.3.用户<strong>使用数字证书进行电子缔约的法律效力等同于传统手写签名或盖章，</strong>由此产生的所有法律后果由用户承担。
    </p>
    <p>
      用户须确认本次申请数字证书的私钥存储方式，并确认充分知悉所选方式的安全风险。根据使用需求，
      <strong>用户选择采用下面第<span style="text-decoration: underline;">  （3）  </span>种私钥存储方式：</strong>
      （1）自行持有私钥并保管；
      （2）<strong>委托大陆云盾托管私钥，</strong>用户授权大陆云盾使用其私钥进行电子签名时，
      须通过以下一种或多种意愿确认方式授权签名行为：
      a）人脸识别；b）短信验证码；c）PIN码；d）音视频双录；
      （3）
      <strong>
        委托
        <span style="text-decoration: underline;">  重庆易保全网络科技有限公司君子签   </span>
        平台托管私钥（即第三方平台托管私钥），
      </strong>用户授权<strong><span style="text-decoration: underline;">  君子签   </span>平台</strong>
      使用其私钥进行电子签名时，须通过以下一种或多种意愿确认方式授权签名行为：a）人脸识别；b）短信验证码；c）PIN码；d）音视频双录。
    </p>
    <p class="indent">
      用户授权大陆云盾调用其数字证书及私钥进行电子签名/电子签章/电子合同签署时，
      确认使用该私钥产生的电子签名代表用户本人的真实意愿，充分理解该授权的含义及有关法律后果，自愿进行授权。
    </p>
    <p class="indent">
      大陆云盾不对用户选择的第三方平台托管私钥的行为及其后果承担审查或担保义务。
      若因第三方平台原因导致签名私钥被未经授权使用、篡改或泄露，
      由此产生的一切法律后果及经济损失，属于用户与该第三方之间的民事纠纷，大陆云盾不承担连带责任。
    </p>
    <h1>第四条 到期更新与撤销</h1>
    <p>
      4.1.数字证书一旦到期将自动失效，
      若用户希望继续使用，应在数字证书到期前向大陆云盾提交更新申请，大陆云盾将依据规则和流程对用户重新进行身份核验。
    </p>
    <p>
      4.2.若用户数字证书对应的私钥发生泄露、损毁、遗失，或发现数字证书被盗用、滥用等情形，用户应立即向大陆云盾申请撤销数字证书。
      数字证书订购在有效期内结束的，大陆云盾将按照以下方式处理：
      （1）数字证书到期且用户未申请更新的，自动失效；
      （2）用户主动申请终止订购的，大陆云盾在批准后24小时内完成撤销；
      （3）因用户违法违规被要求停止服务的，大陆云盾在收到通知后24小时内完成撤销。订购结束后，对于托管的签名私钥，
      大陆云盾将在5个工作日内完成归档并定期安全销毁。
    </p>
    <p>4.3.其他撤销情形详见CPS。</p>
    <h1>第五条 个人信息保护</h1>
    <p>
      5.1.大陆云盾依据合法、正当、必要及最小必要原则，仅收集为办理数字证书业务所必需的用户个人信息，详情参见1.1。
      用户明确授权大陆云盾将本条约定的个人信息仅限于身份核验及数字证书签发目的，
      共享给相关第三方合作机构进行必要查验。未经用户另行书面同意，大陆云盾不得将上述信息用于本协议约定以外的任何其他用途。
    </p>
    <p>
      5.2.大陆云盾将严格遵守《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》《中华人民共和国数据安全法》等法律法规，
      对用户个人信息采取加密存储、访问控制、安全审计等安全保障措施。针对生物识别信息等敏感个人信息，采取单独明示同意、隔离存储、
      禁止对外提供等增强保护措施。
      发生安全事件时，大陆云盾应立即启动应急预案，在法定时限内向监管部门报告，并及时通知受影响的用户。
    </p>
    <p>
      5.3.用户依法享有查阅、更正、删除个人信息及撤回同意等权利，可通过大陆云盾官方渠道行使。
      用户撤回同意的，不影响撤回前基于合法授权已完成的电子签名、电子合同等法律行为的有效性。
    </p>
    <p>
      5.4.针对司法机关、监管机构等依法提出的调查取证、协助执行等要求，
      大陆云盾将依照法律法规的规定提供用户相关信息。该等依法披露行为不视为违反本协议约定的信息保密义务。
    </p>
    <p>
      5.5.完整的个人信息保护条款详见大陆云盾官方网站
      <a href="https://www.msca.org.cn/pip.htm" target="_blank">https://www.msca.org.cn/pip.htm</a>
      公示的《个人信息保护政策》。
    </p>
    <h1>第六条 责任限制与免除</h1>
    <p>
      6.1.若用户提供虚假、过期或不完整信息以获取并使用证书，或未能妥善保管数字证书、私钥、
      密码及其他身份凭证，或在自有系统存在安全缺陷的环境下使用证书，用户需自行承担全部法律责任，并赔偿大陆云盾因此遭受的全部损失。
    </p>
    <p>
      6.2.若大陆云盾已严格遵守法律法规、本协议及CPS的规定，可视为大陆云盾无过错，无需对用户或者依赖方因使用数字证书从事民事、
      商业及政务活动遭受的损失承担赔偿责任，但大陆云盾存在故意或重大过失的除外。以下情形免除大陆云盾责任：
      （1）因不可抗力导致数字证书签发错误、延迟、中断或暂停/终止服务的；
      （2）因非大陆云盾原因的技术故障导致服务问题的；
      （3）证书被超出范围使用或被用于未经大陆云盾允许的用途导致的损失；
      （4）因用户选择的第三方平台托管私钥导致的损失；
      （5）因用户系统安全缺陷、病毒感染、黑客攻击等用户方原因导致的损失；
      （6）因法律法规变化或监管要求导致的服务调整或终止。
    </p>
    <p>
      6.3.用户主张的赔偿应自知道或应当知道损害事实之日起6个月内提出，逾期视为放弃权利，大陆云盾有权拒绝受理。
    </p>
    <p>
      6.4.大陆云盾承诺采用技术措施保障数字证书防伪和防篡改能力，若因责任事故确实导致损失，将按照CPS的规定进行限额赔偿。
      【赔偿限额】除因大陆云盾故意或重大过失造成用户损失外，
      大陆云盾对用户承担的赔偿责任总额不超过用户就该证书服务已实际支付费用的10倍或人民币5万元（以较低者为准）。
      用户同意该赔偿限额系基于数字证书服务的技术特性及行业惯例合理设定，不属于不合理减轻大陆云盾责任的格式条款。
    </p>
    <h1>第七条 其他</h1>
    <p>
      7.1.【联系方式与用户权利行使】大陆云盾设立以下服务渠道，用户可通过相应方式联系我们：（
      1）技术服务热线：400-156-9659（工作时间：法定工作日09:00-21:00）；
      （2）投诉与监督电话：023-62987966。用户如需撤销数字证书、撤回个人信息处理授权或获取政策解释的，可通过以上联系方式提出。
      用户撤回个人信息处理授权的，
      不影响撤回前大陆云盾基于合法授权已进行的个人信息处理活动的效力，亦不影响撤回前已完成的电子签名、电子合同等法律行为的有效性。
    </p>
    <p>
      7.2.【协议更新】大陆云盾有权根据法律法规变化及业务需要，不定期修订本协议及CPS。
      修订后的协议将提前不少于30日在大陆云盾官方网站
      （<a href="https://www.msca.org.cn" target="_blank">https://www.msca.org.cn</a>）予以公布，
      并说明修订内容与生效日期。修订后的协议自公布期限届满之日起正式生效。
      <strong>用户有义务定期查阅网站公告，大陆云盾不再另行单独通知每位用户。</strong>
      用户可选择继续使用证书服务（视为接受修订后的协议）或终止服务：
      若用户不同意修订后的协议，应于生效前通过大陆云盾官方渠道申请撤销数字证书；
      若用户在前款期限内未提出申请，视为已接受修订后的协议，修订后的协议对双方均具有约束力。
    </p>
    <p>
      7.3.【完整协议】本协议、CPS及《个人信息保护政策》共同构成双方关于数字证书服务的完整协议，
      取代双方此前就该事项达成的所有口头或书面约定。用户使用大陆云盾数字证书服务，应同时遵守前述全部文件的规定。
    </p>
    <p>
      7.4.【协议的订立与生效】本协议采用电子数据形式或纸质书面形式订立，两者具有同等法律效力。
      用户通过以下任一方式确认本协议，即视为本协议正式订立并生效：
      （1）在线申请时，勾选"已阅读并同意《数字证书服务协议》"并提交申请；
      （2）线下办理时，在本协议纸质文本上签字或盖章；（3）完成数字证书下载或首次使用电子签名功能。
    </p>
    <p>
      7.5.【协议有效期与终止】本协议的有效期与所申请数字证书的有效期一致。
      本协议在以下任一情形发生时终止：
      （1）数字证书有效期届满且用户未申请续期；
      （2）大陆云盾依法拒绝签发数字证书；
      （3）数字证书被依法撤销或注销；
      （4）用户依本协议约定申请终止服务并完成证书注销手续。
    </p>
    <p>
      7.6.【知识产权】大陆云盾提供的数字证书、CPS、相关技术文档及系统的知识产权均归大陆云盾所有。
      用户仅获得按照本协议约定使用数字证书的权利，不得复制、修改、反向工程、反编译或以其他方式侵犯大陆云盾的知识产权。
    </p>
    <p>
      7.7.【法律适用与争议解决】本协议的订立、效力、解释、履行及争议的解决，均适用中华人民共和国法律（不包括冲突规范）。
      因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决；协商不成的，
      任何一方均有权将争议提交大陆云盾住所地有管辖权的人民法院通过诉讼解决；
      如争议金额不超过人民币50万元的，双方同意提交重庆仲裁委员会按照其届时有效的仲裁规则进行仲裁，仲裁裁决为终局裁决。
    </p>
    <p>
      7.8.【可分割性】本协议任何条款被有权机关认定为无效、违法或不可执行的，不影响本协议其余条款的效力，
      其余条款继续有效并对双方具有约束力。
      本协议标题仅为阅读方便而设，不影响本协议任何条款的含义与解释。如有中英文版本歧义的，以中文版本为准。
    </p>
    <div style="margin-top: 3vh;display: flex;justify-content: flex-end;">
      <div style="width: 30%;">
        <P>大陆云盾电子认证服务有限公司</P>
        <P>版 本 号： V1.1</P>
        <P>发布日期： 2026年 05月15日</P>
        <P>生效日期： 2026年 06月16日</P>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    methods: {
    },
    mounted() {
    },
    data() {
      return {
      };
    },
    computed: {
    },
  };
</script>

<style lang="less" scoped>
.indent{
  text-indent: 2em;
}
.title {
  font-size: 18px;
  text-align: center;
  line-height: 1.5;
  margin: 10px 0;
}

.content {
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  font-stretch: normal;
  font-size: 12px;
  font-family: "Microsoft YaHei", Arial;
  line-height: 24px;
  color: rgb(91, 91, 91);
  display: block;
}
</style>



// WEBPACK FOOTER //
// components/protocol/pItems/daluyundun.vue